<template>
  <div v-if="$store.getters.loading"></div>
  <div v-else>
    <template v-if="playerFinalCombinado.player !== null">
      <DialogConfirmationPlayerFinal v-if="esWizardJugadores" title="¿Seguro que desea confirmar?"
        text="Los datos del jugador duplicado serán combinados con los datos del jugador original. Esta acción no se puede deshacer"
        ref="DialogConfirmationPlayerFinalRef" :executeFunction="combinarJugadoresApi">
      </DialogConfirmationPlayerFinal>
      <DialogConfirmationPlayerFinal v-else title="¿Seguro que desea confirmar?"
        text="Los datos del personal duplicado serán combinados con los datos del personal original. Esta acción no se puede deshacer"
        ref="DialogConfirmationPlayerFinalRef" :executeFunction="combinarJugadoresApi">
      </DialogConfirmationPlayerFinal>
      <v-card>
        <v-layout row wrap>
          <v-flex xs3 md2 pt-4 pl-2 ml-2 pb-4 v-if="photoPersonal !== ''">
            <v-img :src="photoPersonal" max-height="150px" contain v-if="photoPersonal"></v-img>
            <div class="text-xs-center pt-2" v-if="!photoPersonal">
              <v-icon color="grey" large>account_box</v-icon>
            </div>
          </v-flex>
          <v-flex xs8 md7>
            <v-card-title primary-title>
              <div>
                <div class="headline">{{ playerFinalCombinado.player.firstName }} {{
                  playerFinalCombinado.player.lastName }}</div>
                <v-divider class="my-2"></v-divider>
                <div><b>Nacionalidad:</b> {{ playerFinalCombinado.player.country.name }}</div>
                <div><b>DNI:</b> {{ playerFinalCombinado.player.dni || '-' }}</div>
                <div v-if="playerFinalCombinado.player.pasaporte"><b>Pasaporte:</b> {{
                  playerFinalCombinado.player.pasaporte }}</div>
                <div><b>Fecha de nacimiento:</b> {{ playerFinalCombinado.player.dateOfBirth }}</div>
                <!--                 <div v-if="cuerpoTecnico"><b>Rol:</b> {{ playerFinalCombinado.rolDisplay }}</div>
 -->
              </div>
            </v-card-title>
          </v-flex>
        </v-layout>
      </v-card>
    </template>
    <div v-if="personal !== null" class="custom-font-light large-text custom-blue-text mb-1 mt-5">
      <v-icon color="grey">gavel</v-icon>
      <span style="font-size: large; margin-left: 5px;">Contratos combinados (Vista previa)</span>
    </div>
    <template>
      <WizardContractsTable :contratosCombinados="contratosFinalCombinado" :pantallaFinal="true"
        @update:items="contratos = $event" :playerFinalCombinado="playerFinalCombinado.player"
        :club="playerFinalCombinado.player.club">
      </WizardContractsTable>
    </template>
    <v-btn style="margin-top: 20px;" color="primary"
      @click="$refs.DialogConfirmationPlayerFinalRef.openDialogNewPlayer()">Combinar</v-btn>

  </div>

</template>

<script>
import DialogConfirmationPlayerFinal from './DialogConfirmationPlayerFinal.vue'
import WizardContractsTable from './WizardContractsTable.vue'

export default {
  components: { WizardContractsTable, DialogConfirmationPlayerFinal },
  props: {
    playerFinalCombinado: {
      type: Object,
      default: () => null
    },
    contratosFinalCombinado: {
      type: Array,
      default: () => []
    },
    photoPersonal: {
      type: String,
      default: ''
    },
    esWizardJugadores: {
      type: Boolean,
      default: () => null
    }
  },

  data () {
    return {
      path: 'playersWizard?',
      page_size: 10,
      page: 1,
      qSearch: '',
      filterPath: 'filters/players',
      search: '',
      items: [],
      searchText: 'Buscar jugador',
      selectedPlayer: null,
      pagination: {
        sortBy: 'firstName',
        descending: false,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0
      },
      contratos: []
    }
  },
  methods: {
    handlePlayerSelected (player) {
      this.selectedPlayer = player
      this.fetchDataPlayer()
    },
    setItems (responseData) {
      this.items = responseData.results
    },
    onPaginationChange (newPagination) {
      this.pagination.page = newPagination.page
      this.buscarJugador()
    },
    fetchDataPlayer () {
      this.loading = true
      this.axios
        .get('player/' + this.selectedPlayer.player.pk + '/' + this.selectedPlayer.club.pk)
        .then(response => {
          this.playerFinalCombinado = response.data
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    combinarJugadoresApi () {
      this.loading = true
      let payload = {
        original_player: this.playerFinalCombinado.player.originalPk,
        duplicated_player: this.playerFinalCombinado.player.duplicatedPk,
        dni: this.playerFinalCombinado.player.dni,
        pasaporte: this.playerFinalCombinado.player.pasaporte
      }
      this.axios
        .put(`playersWizard/update_contractual_statuses/${this.playerFinalCombinado.player.originalPk}`, payload)
        .then(response => {
          this.$router.go()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    async buscarJugador () {
      this.selectedPlayer = null
      this.loading = true
      if (!this.search) {
        this.items = []
        this.loading = false
        return
      }

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        q: this.search
      }

      try {
        const response = await this.axios.get(this.path, { params })
        this.items = response.data.results
        this.pagination = {
          ...this.pagination,
          totalItems: response.data.count
        }
        this.loading = false
      } catch (error) {
        /* this.loading = false
        let validError = error?.response?.data?.detail
        if (validError && error.response.data.detail.includes('Página inválida')) {
          this.pagination.page = 1
        } else {
          this.$store.commit('setErrorMsg', error)
        } */
      }
    }
  },
  watch: {
    contratos: {
      handler (newVal) {
        if (newVal) {
          this.$emit('update:items', newVal)
        }
      },
      deep: true,
      immediate: true
    },
    playerFinalCombinado: {
      handler (newVal) {
        if (newVal) {
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
